import { NetworkType } from '@layerswap/widget-types';
import KnownInternalNames from '@layerswap/utils/known-ids';
import { detectPocketUniverse } from '../lib/pocketUniverse';
export function shouldUseDepository({ from, fromAsset, depositMethod, fromExchange }, sourceIsSupported, sourceAddress) {
    const usePocketUniverseDepository = depositMethod === 'wallet' && !fromExchange && sourceIsSupported && !!sourceAddress
        && from?.type === NetworkType.EVM && !!fromAsset && fromAsset.symbol === from.token?.symbol && !fromAsset.contract && detectPocketUniverse();
    return from?.name === KnownInternalNames.Networks.StellarTestnet || from?.name === KnownInternalNames.Networks.StellarMainnet || usePocketUniverseDepository;
}
